import { defineMessages } from 'react-intl';

const definedMessages = defineMessages({
  setupCodeNoLength: {
    id: 'app.auth.setup_code_no_length',
    description: 'setup code message',
    defaultMessage: 'Setup code',
  },
  email: {
    id: 'app.auth.email',
    description: 'email message',
    defaultMessage: 'Email',
  },
  password: {
    id: 'app.auth.password',
    description: 'password message',
    defaultMessage: 'Password',
  },
});

export default definedMessages;



// WEBPACK FOOTER //
// ./src/components/setup/authenticate/i18n.jsx